<template>
    <div>
        <input
            :name="name"
            type="text"
            v-bind="combinedAttributes"
            v-model="innerValue"
            class="form-control my-1"
            :class="{ 'has-error': hasError }"
        >
    </div>
</template>

<script>
    import ValueForwarder from '~/mixins/value-forwarder'

    export default {
        name: 'ad-text',
        mixins: [
            ValueForwarder,
        ],

        props: {
            name: {
                required: true,
            },
            properties: {
                required: false,
                default: () => {
                    return {};
                },
            },
            options: {
                required: false,
            },
            trajectoryEnrolment: {
                type: Object,
                required: false,
            },
            actionProgress: {
                type: Object,
                required: false,
            },
            actionProgressId: {
                type: Number,
                required: false,
            },
            check: {
                type: Boolean,
                default: false,
            },
            checkId: {
                type: Number,
                required: false,
            },
        },
        computed: {
            combinedAttributes() {
                return {
                    ...this.properties,
                    ...this.$attrs
                };
            }
        },
        mounted() {
            if (this.name === 'DJ6kSMcl0H' && (this.innerValue === '' || this.innerValue == null || this.innerValue === undefined)) {
                this.retrieveReport();
            }
        },
        methods: {
            async retrieveReport() {
                try {
                    const response = await axios.get(`/api/fetch-all-report-data/${this.trajectoryEnrolment.id}/${this.actionProgress.id ? this.actionProgress.id : ''}`);
                    const suggestStartDate = response.data.allActionProgresses[0].suggestStartDate;
                    const suggestEndDate = response.data.allActionProgresses[0].suggestEndDate;
                    this.innerValue = suggestStartDate+' t/m '+suggestEndDate;
                } catch (error) {
                    console.error('Failed to fetch report data:', error);
                }
            }
        },
    };
</script>

<style scoped>
.has-error {
    border-color: #d9534f;
}
</style>
